module.exports = __webpack_public_path__ + "static/media/don-ads.473a514b.jpg";